import "core-js/stable";
import "regenerator-runtime/runtime";

//for IE, Edge polyfill
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import objectFitImages from 'object-fit-images';
objectFitImages();

import './_ie11';

import './_dropdown.js';
import './_global-nav.js';
import './area-map/_modal.js';
import './area-map/_slider.js';
import './plan/_slider.js';
import './home/_slider.js';
import './home/_marquee.js';

//for form
import './form/_zipcode';
import './form/_add-order';
import './form/payment/_base';
